module.exports = __webpack_public_path__ + "img/staff_delete.ac0230bf.svg";